import React, { useState } from "react";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";
import {
  getHashdataUrl,
  setHashUrl,
} from "../../../../../../../components/Tabs/Utils/hashFunctions";
import MRQProvider from "./MRQContext";
import MRQBOM from "./MRQBOM";
import Scope from "./Scope";
import Attachments from "./Attachments";
import VendorDataReq from "./VendorDataReq";
import ITP from "./ITP";

const MRQ_TABS = [
  { label: "MRQ BOM", panel: <MRQBOM /> },
  { label: "Scope", panel: <Scope /> },
  { label: "Attachments", panel: <Attachments /> },
  { label: "Vendor Data Req.", panel: <VendorDataReq /> },
  { label: "ITP", panel: <ITP /> },
];

const NAV_LABEL = "mrq-tab";

export default function MRQPage() {
  const { plantId } = useParams();
  const { plant } = useRoutePlant();
  const [currentTab, setCurrentTab] = useState(0);

  React.useEffect(() => {
    const hashValue = getHashdataUrl(NAV_LABEL);
    const tabIndex = MRQ_TABS.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue),
    );
    if (tabIndex !== -1) {
      setCurrentTab(tabIndex);
    } else {
      setHashUrl(NAV_LABEL, MRQ_TABS[0].label);
    }
  }, []);

  const handleChange = (_, newValue) => {
    setCurrentTab(newValue);
    setHashUrl(NAV_LABEL, MRQ_TABS[newValue].label);
  };

  return (
    <MRQProvider>
      <Box>
        <PageHeader plant={plant} pageTitle="Material Requisition (MRQ)" />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: 1,
            borderColor: "divider",
            px: 2,
          }}
        >
          <Tabs
            value={currentTab}
            onChange={handleChange}
            orientation="horizontal"
          >
            {MRQ_TABS.map((tab, i) => (
              <Tab key={tab.label} label={tab.label} value={i} />
            ))}
          </Tabs>
          <Button variant="outlined" size="small">
            MRQ Register
          </Button>
        </Box>
        <Box sx={{ p: 2 }}>{MRQ_TABS[currentTab].panel}</Box>
      </Box>
    </MRQProvider>
  );
}
